export const dictionaryLinks = {
  dictionary: () => "/dictionary",
  category: (categoryId: string) => `/dictionary/${categoryId}`,
};
